// extracted by mini-css-extract-plugin
export default {"wrapper":"gNM_Mvwa9SlionFHFasQ","leftSideHeader":"thzMhGLfWci68jOqEypn","title":"xCMcwQYN654BoqOe6_9y","addDataConnectionButton":"dh0KcngylOrwT1b3bGP1","tabs":"YkYu9z8JPu46kBcQSFlQ"};